import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ProfileService } from '../../profile.service';
import { User } from '../../types/user.model';
import { AuthService } from '../../../public/auth.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'mmb-web-app-edit-personal-details-modal',
  templateUrl: './edit-personal-details-modal.component.html',
  styleUrls: ['./edit-personal-details-modal.component.scss']
})
export class EditPersonalDetailsModalComponent implements OnInit {
  @Output() addSuccess: EventEmitter<any> = new EventEmitter<any>();
  @Output() closed: EventEmitter<any> = new EventEmitter<any>();
  @Input() form: UntypedFormGroup;
  @Input() user: User;

  constructor(private profileService: ProfileService, private authService: AuthService, private toastr: ToastrService) { }

  ngOnInit() {
  }

  onSave() {
    let isNameFieldsDirty = false;
    let isEmailFieldDirty = false;
    isNameFieldsDirty = this.form.controls['firstName'].dirty || this.form.controls['lastName'].dirty;
    isEmailFieldDirty = this.form.controls['email'].dirty;

    if (isNameFieldsDirty) {
      // name changed
      this._updateDetails().subscribe(() => {
        this.addSuccess.emit({
          firstName: this.form.controls['firstName'].value,
          lastName: this.form.controls['lastName'].value,
          email: this.form.controls['email'].value,
        });
      });
    }
    if (isEmailFieldDirty) {
      this._updateEmail().subscribe({
        next: () => {
          this.addSuccess.emit({
            firstName: this.form.controls['firstName'].value,
            lastName: this.form.controls['lastName'].value,
            email: this.form.controls['email'].value,
          });
        },
        error: (err) => {
          if (err?.status === 429) {
            const msg = err?.error?.message || 'Too many attempts. Please try again later.';
            this.toastr.error(msg, 'Rate limit');
          } else {
            this.toastr.error('Unable to change email. Please try again later.', 'Error');
          }
        }
      });
    }

    if(!isNameFieldsDirty && !isEmailFieldDirty) {
      // no changes done
      this.addSuccess.emit();
    }
  }

  onClose() {
    this.closed.emit();
  }

  private _updateEmail() {
    return this.authService.changeEmail(this.form.controls['email'].value);
  }

  private _updateDetails() {
    return this.profileService
      .updateUserNameByUuid(this.form.controls['firstName'].value, this.form.controls['lastName'].value, this.user.uuid);
  }
}
